
























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component({})
export default class GenericToggleButton extends Vue {
  @Prop({type: Boolean, default: false}) default!: boolean | undefined

  value = this.default ?? false

  @Watch('default')
  onDefaultChange(next: boolean | undefined) {
    // Keep internal state in sync when parent re-fetches data.
    this.value = next ?? false
  }

  changeValue(event: Event) {
    event.stopPropagation()

    this.value = !this.value
    this.$emit('handleToggle', this.value)
  }
}
